import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBankAccounts = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		transform: "translate(0 0) scale(1.7143)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M1.94418 4.81492V10.5916M5.19358 4.81492V10.5916M8.80403 4.81492V10.5916M12.0534 4.81492V10.5916M0.5 11.747L0.5 12.3247C0.5 12.7291 0.5 12.9313 0.578703 13.0857C0.647932 13.2216 0.758398 13.3321 0.894268 13.4013C1.04873 13.48 1.25094 13.48 1.65534 13.48H12.3423C12.7467 13.48 12.9489 13.48 13.1033 13.4013C13.2392 13.3321 13.3497 13.2216 13.4189 13.0857C13.4976 12.9313 13.4976 12.7291 13.4976 12.3247V11.747C13.4976 11.3426 13.4976 11.1404 13.4189 10.9859C13.3497 10.85 13.2392 10.7396 13.1033 10.6703C12.9489 10.5916 12.7467 10.5916 12.3423 10.5916H1.65534C1.25094 10.5916 1.04873 10.5916 0.894268 10.6703C0.758398 10.7396 0.647932 10.85 0.578703 10.9859C0.5 11.1404 0.5 11.3426 0.5 11.747ZM6.74818 0.538081L1.40471 1.72552C1.0819 1.79725 0.920487 1.83312 0.800003 1.91992C0.69373 1.99649 0.610283 2.10051 0.558597 2.22086C0.5 2.35731 0.5 2.52266 0.5 2.85335L0.5 3.65958C0.5 4.06399 0.5 4.26619 0.578703 4.42066C0.647932 4.55653 0.758398 4.66699 0.894268 4.73622C1.04873 4.81492 1.25094 4.81492 1.65534 4.81492H12.3423C12.7467 4.81492 12.9489 4.81492 13.1033 4.73622C13.2392 4.66699 13.3497 4.55653 13.4189 4.42066C13.4976 4.26619 13.4976 4.06399 13.4976 3.65958V2.85335C13.4976 2.52266 13.4976 2.35731 13.439 2.22086C13.3873 2.10051 13.3039 1.99649 13.1976 1.91992C13.0771 1.83312 12.9157 1.79725 12.5929 1.72552L7.24944 0.538081C7.15591 0.517297 7.10914 0.506904 7.06189 0.50276C7.01991 0.49908 6.9777 0.49908 6.93573 0.50276C6.88847 0.506904 6.84171 0.517297 6.74818 0.538081Z",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	})]
});
const ForwardRef = forwardRef(SvgBankAccounts);
export default ForwardRef;
